import { render } from "preact";
import { App } from "./app";
import { captureAuthError, initAuth } from "./state";
import "./styles/app.css";

const root = document.getElementById("app");
if (!root) throw new Error("Missing #app root element");

// Before anything routes: the OAuth callback's error params only survive until
// the router rewrites the URL, so lift them into a signal first.
captureAuthError();
void initAuth();
render(<App />, root);
